import { render, staticRenderFns } from "./DonutChart78.vue?vue&type=template&id=29ebbd35&scoped=true"
import script from "./DonutChart78.vue?vue&type=script&lang=js"
export * from "./DonutChart78.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ebbd35",
  null
  
)

export default component.exports